import { Encoding } from './Encoding';
import { AST, ExpressionDSL, Dimension, DimensionEncoding, Method, ParserSymbol, Expr } from './AST';

export class EncodingSerializer {
    /**
     *
     * @param {AST} ast
     * @returns {Encoding}
     */
    static serialize(ast: AST): Encoding {
        const encoding = Object.keys(ast.dimensions).reduce(
            (encodingEntry, name: string) => {
                // eslint-disable-next-line no-param-reassign
                encodingEntry.dimensions[name] = EncodingSerializer.dimension(ast.dimensions[name]);
                return encodingEntry;
            },
            { dimensions: {}, context: {} }
        );
        Object.assign(encoding.context, ast.context);
        return encoding;
    }

    static dimension(dimension: Dimension): DimensionEncoding {
        const { value } = dimension;
        return { value: EncodingSerializer.dsl(value) };
    }

    static expr(expr: Expr): string {
        if (expr.type === 'method') {
            return EncodingSerializer.method(expr);
        }
        const p = expr as ParserSymbol;
        if (p.type === 'string') {
            return `'${p.v}'`;
        }
        return p.v.toString();
    }

    static method(op: Method): string {
        const { name, args } = op;
        const methodCallOpening = `${name}(`;
        return `${args.reduce((acc: string, curArg: ParserSymbol, i) => {
            const maybeComma = i < args.length - 1 ? ',' : '';
            return acc + EncodingSerializer.expr(curArg) + maybeComma; // `foo(bar, baz,` + 'zap,?'
        }, methodCallOpening)})`; // initial value is foo( // must close the method call with paren
    }

    static dsl(exprs: Expr[]): ExpressionDSL {
        return exprs.reduce((commandStr, expr: Expr, i) => {
            // eslint-disable-next-line no-param-reassign
            commandStr += (i > 0 ? '|' : '') + EncodingSerializer.expr(expr);
            return commandStr;
        }, '');
    }
}
